<template>
  <div class="page">
    <title1 class="title-scale" type="1" title="AI模型" style="margin-top: 30px" />
    <div class="centerRound">
      <div class="Totaltop-up mt-90">
        <div class="count">
          {{ (Number(target).toFixed(0)) }}<span>个</span>
        </div>
        <div class="label">大模型数量</div>
      </div>
    </div>
    <div class="centerBody"></div>
  </div>
</template>

<script>
import { dataInterface } from "@/api/dataInterfaceApi";
import title1 from '@/views/exposition/components/title2'
export default {
  components: {
        title1,
    },
  data() {
    return {
      target: '',
    };
  },
  mounted() {
    this.getbatteryCharging();
  },
  methods: {
    // 实时负载
    getbatteryCharging() {
      let params = {
        enCode: "computingpower-right-ssfz",
      };
      dataInterface.dataFaceApi(params).then((res) => {
        console.log(res, "实时负载");
        this.target = res[4].load || '';
      });
    },
    addCommas(number) {
      const parts = number.toString().split(".");
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      return parts.join(".");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../comm.scss";
.page {
  width: 100%;
  height: 580px;
  //   background: red;
  .centerRound {
    position: absolute;
    top: 3.5%;
    left: 39%;
    // transform: translate(-50%, -50%);
    width: 300px;
    height: 300px;
    background: url(~@/assets/images/computility/centerRound-2.png) no-repeat
      center center;
    background-size: 100% 100%;
    animation: Beating1 2.2s linear infinite;
    z-index: 10;
  }
  .centerBody {
    position: absolute;
    left: -10%;
    top: 10%;
    // transform: translate(-50%, 50%);
    width: 130%;
    height: 400px;
    background: url(~@/assets/images/computility/centerBody-1.png) no-repeat
      center center;
    background-size: 100% 100%;
    animation: breath_light 5s ease infinite;
  }
  // background: green;
  .Totaltop-up {
    .count {
      margin-left: 110px;
      @include ffamily-DS;
      font-size: 78px;
      span {
        font-size: $FontSize24;
      }
    }
    .label {
      line-height: 10px;
      margin-left: 65px;
      font-size: $FontSize36;
    }
  }
}

@keyframes Beating1 {
  0% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(60px);
  }
  100% {
    transform: translateY(0);
  }
}
.img {
  animation: breath_light 3s ease infinite;
}
</style>